/* unplugin-vue-components disabled */import { render } from "./title.vue?vue&type=template&id=c2794c60"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wuxieshuan/Desktop/上海印高/WeCom_FE/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/menu-head/title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2794c60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2794c60', __exports__)) {
    console.log('reload')
    api.reload('c2794c60', __exports__)
  }
  
  module.hot.accept("./title.vue?vue&type=template&id=c2794c60", () => {
    console.log('re-render')
    api.rerender('c2794c60', render)
  })

}


export default __exports__